/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

$(function() {
  if ($('[data-review-modal]').length > 0) { return; }

  $('#review [data-section-title] a').click(function() {
    $('.js-review-submit').removeAttr('disabled');
    $('.js-review-submit').text('Submit Review');
    $('form#new_review').clearErrors();
    return $('.action-bar-flash .alert').remove();
  });

  $('form#new_review input[name="review[rating]"]').change(function() {
    if ($(this).is(':checked')) {
      const kiwi_label = $(this).closest('label');
      kiwi_label.nextAll('.radio').find('input[name="review[rating]"]').removeClass('checked');
      kiwi_label.nextAll('.radio').find('input[name="review[rating]"]').parent().removeClass('checked');
      $(this).addClass('checked');

      $(this).parent().addClass('checked');
      kiwi_label.prevAll('.radio').find('input[name="review[rating]"]').addClass('checked');
      return kiwi_label.prevAll('.radio').find('input[name="review[rating]"]').parent().addClass('checked');
    }
  });

  $('form#new_review input[name="review[rating]"]:checked').trigger('change');


  $('.write-a-review').click(function(e) {
    if ($('#write-a-review')[0] != null) {
      e.preventDefault();
      $.openActionBar('#review');
      return $('#write-a-review').click(); //switch to tab.
    } else {
      return location.href = $(this).attr('href');
    }
  });

  $('.view-all-reviews').click(function(e) {
    e.preventDefault();
    $('#reviews-tab').selectTab();
    return $.openActionBar('#review');
  });

  $('.js-review-delete').click(function(e) {
    if (confirm('Are you sure?')) {
    } else {
      return e.preventDefault();
    }
  });

  return $('.js-review-edit').click(function(e) {
    e.preventDefault();

    let {
      target
    } = e;

    // click edit button not in action pane
    if ($(e.target).hasClass('js-inline-review')) {
      $.openActionBar('#review');
      const action_pane_edit_button = $('.action-pane .js-review-edit');
      action_pane_edit_button.trigger("click");
      target = action_pane_edit_button;
    }

    const review_form = $('#new_review');

    const review_to_edit = $(target).parents('li.review');

    const kiwis = review_form.find('.js-review-kiwis input');
    review_to_edit.find('.kiwi--active').each((i, el) => $(kiwis[i]).addClass('checked'));

    review_form.find('.js-review-title').val(review_to_edit.find('.js-review-title').text());

    let pros_text = '';
    review_to_edit.find('.js-review-pros').each((i, e) => pros_text = pros_text + $(e).text() + '\n');
    review_form.find('.js-review-pros').val(pros_text);

    let cons_text = '';
    review_to_edit.find('.js-review-cons').each((i, e) => cons_text = cons_text + $(e).text() + '\n');
    review_form.find('.js-review-cons').val(cons_text);

    // add correct method and action to form
    const crud_method = document.createElement('input');
    crud_method.type="hidden";
    crud_method.name="_method";
    crud_method.value="put";

    review_form[0].action = target.attributes['data-url'].value;
    review_form.append(crud_method);

    $('.js-review-edit').hide();
    $('.js-review-delete').hide();

    $('.js-review-cancel').show();
    review_form.hide();

    review_to_edit.append(review_form);
    $(target).parents('.js-review-content').slideUp();
    review_form.slideDown();

    const recom = $('[data-recommended]').attr('data-recommended');

    switch (recom) {
      case '1':
        $('#review_recommended_1').click();
        break;
      case '0':
        $('#review_recommended_0').click();
        break;
      case '-1':
        $('#review_recommended_-1').click();
        break;
    }

    return $('.js-review-cancel').click(function(e) {
      e.preventDefault();
      return window.location.reload();
    });
  });
});
